// ==========================================================================
// YEEZY KARUZELA (zawsze widoczna sekcja - nie okienko)
// Strzałki + swipe/przeciąganie LEWO-PRAWO = zdjęcia TEGO SAMEGO produktu.
// Swipe/przeciąganie GÓRA-DÓŁ = następny/poprzedni PRODUKT (bez strzałek).
// Przejścia: natywne View Transitions API przeglądarki (ten sam mechanizm,
// którego najpewniej używa yeezy.com) - przeglądarka sama przenika stary i
// nowy stan zdjęcia, bez naszej ręcznej animacji. Fallback: zwykła,
// natychmiastowa zmiana w przeglądarkach bez wsparcia.
// "+" dodaje do koszyka, zdjęcie leci "duchem" w stronę koszyka.
// ==========================================================================
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-yeezy-carousel]');
    roots.forEach(initCarousel);
  });

  function initCarousel(root) {
    var stage = root.querySelector('.yeezy-carousel__stage');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.yeezy-carousel__slide'));
    if (!slides.length) return;

    var dotsWrap = root.querySelector('[data-yeezy-carousel-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.yeezy-carousel__dot')) : [];
    var prevBtn = root.querySelector('[data-yeezy-carousel-prev]');
    var nextBtn = root.querySelector('[data-yeezy-carousel-next]');

    var currentProductIndex = 0;
    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) currentProductIndex = i;
    });

    // ---------------------------------------------------------------------
    // DODAWANIE DO KOSZYKA - rejestrowane NAJPIERW (przed nawigacją/swipe),
    // żeby ewentualny błąd niżej w kodzie nigdy nie zablokował "+".
    // ---------------------------------------------------------------------
    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-yeezy-carousel-add-toggle]');
      var variantOption = event.target.closest('[data-variant-option]');

      if (toggle) {
        var wrap = toggle.closest('[data-yeezy-carousel-add-wrap]');
        var picker = wrap ? wrap.querySelector('[data-yeezy-carousel-variant-picker]') : null;
        var variants = [];
        try {
          variants = JSON.parse((wrap && wrap.getAttribute('data-variants')) || '[]');
        } catch (e) {
          variants = [];
        }

        if (variants.length > 1 && picker) {
          if (picker.hidden) {
            renderVariantPicker(picker, variants);
            picker.hidden = false;
            toggle.textContent = '−';
          } else {
            picker.hidden = true;
            toggle.textContent = '+';
          }
          return;
        }

        var singleVariantId = variants.length ? variants[0].id : null;
        if (singleVariantId) addToCart(singleVariantId, toggle);
        return;
      }

      if (variantOption) {
        if (variantOption.disabled) return;
        var variantId = variantOption.getAttribute('data-variant-option');
        var wrapEl = variantOption.closest('[data-yeezy-carousel-add-wrap]');
        var toggleBtn = wrapEl.querySelector('[data-yeezy-carousel-add-toggle]');
        var pickerEl = wrapEl.querySelector('[data-yeezy-carousel-variant-picker]');
        toggleBtn.textContent = '+';
        addToCart(variantId, toggleBtn);
        pickerEl.hidden = true;
      }
    });

    function renderVariantPicker(picker, variants) {
      picker.innerHTML = '';
      variants.forEach(function (variant) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = variant.title;
        button.setAttribute('data-variant-option', variant.id);
        if (!variant.available) button.disabled = true;
        picker.appendChild(button);
      });
    }

    function addToCart(variantId, toggleBtn) {
      var original = toggleBtn.textContent;
      toggleBtn.disabled = true;
      toggleBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-to-cart-failed');
          return fetch('/cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var cartCountEl = document.querySelector('[data-yeezy-cart-count]');
          if (cartCountEl) cartCountEl.textContent = cart.item_count;

          var slide = toggleBtn.closest('.yeezy-carousel__slide');
          var imgEl = slide ? slide.querySelector('.yeezy-carousel__image') : null;
          if (window.yeezyFlyToCart && imgEl) window.yeezyFlyToCart(imgEl);

          toggleBtn.textContent = '✓';
          setTimeout(function () {
            toggleBtn.textContent = original;
            toggleBtn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          toggleBtn.textContent = '!';
          setTimeout(function () {
            toggleBtn.textContent = original;
            toggleBtn.disabled = false;
          }, 1500);
        });
    }

    // ---------------------------------------------------------------------
    // Zdjęcia danego produktu (dane w data-images na .yeezy-carousel__media)
    // ---------------------------------------------------------------------
    function getMedia(slide) {
      return slide.querySelector('[data-yeezy-media]');
    }

    function getImages(slide) {
      var media = getMedia(slide);
      if (!media) return [];
      try {
        return JSON.parse(media.getAttribute('data-images') || '[]');
      } catch (e) {
        return [];
      }
    }

    function getImageIndex(slide) {
      var media = getMedia(slide);
      return media ? parseInt(media.getAttribute('data-current-index') || '0', 10) || 0 : 0;
    }

    function preloadImage(src, callback) {
      if (!src) {
        callback();
        return;
      }
      var loader = new Image();
      loader.onload = callback;
      loader.onerror = callback;
      loader.src = src;
    }

    // Ustawia zdjęcie SYNCHRONICZNIE - zakłada że jest już w cache (patrz
    // preloadImage wywoływane WCZEŚNIEJ, zawsze przed applyImage). Jeden
    // rozmiar, bez dogrywania jakości w tle i bez przyciemniania - stąd
    // nigdy nie widać "szarego, ładującego się" stanu.
    function applyImage(slide, index) {
      var media = getMedia(slide);
      if (!media) return;
      var images = getImages(slide);
      var item = images[index];
      if (!item) return;

      media.setAttribute('data-current-index', index);
      var img = media.querySelector('.yeezy-carousel__image');
      img.setAttribute('src', item.src);
      img.setAttribute('alt', item.alt || '');

      updateImageNav(slide);
    }

    function updateImageNav(slide) {
      var images = getImages(slide);
      var hide = images.length <= 1;
      if (prevBtn) prevBtn.hidden = hide;
      if (nextBtn) nextBtn.hidden = hide;
    }

    // Kierunkowe odsłonięcie: nowe zdjęcie "wjeżdża" zza krawędzi w danym
    // kierunku. W połowie animacji (gdy odsłona jest w toku) podmieniamy
    // zdjęcie, więc widz widzi już nową treść wjeżdżającą, nie stare.
    // direction: 'ltr' | 'rtl' | 'ttb' | 'btt'
    function withWipeTransition(el, direction, callback) {
      if (!el) {
        callback();
        return;
      }
      var className = 'is-wiping-' + direction;
      callback();
      el.classList.remove('is-wiping-ltr', 'is-wiping-rtl', 'is-wiping-ttb', 'is-wiping-btt');
      void el.offsetWidth; // restart animacji nawet przy tym samym kierunku z rzędu
      el.classList.add(className);

      setTimeout(function () {
        el.classList.remove(className);
      }, 480);
    }

    // Pierwsze zdjęcie na starcie CZEKA aż faktycznie się załaduje zanim
    // się pokaże - żadnego "pojawia się i dogrywa" nawet przy pierwszym
    // wejściu na stronę.
    function preloadProductImages(index) {
      var slide = slides[index];
      if (!slide) return;
      var images = getImages(slide);
      var item = images[getImageIndex(slide)];
      preloadImage(item && item.src, function () {
        applyImage(slide, getImageIndex(slide));
      });
    }

    function showPrevImage() {
      var slide = slides[currentProductIndex];
      var images = getImages(slide);
      if (images.length < 2) return;
      var idx = (getImageIndex(slide) - 1 + images.length) % images.length;
      var img = slide.querySelector('.yeezy-carousel__image');
      preloadImage(images[idx].src, function () {
        withWipeTransition(img, 'rtl', function () {
          applyImage(slide, idx);
        });
      });
    }

    function showNextImage() {
      var slide = slides[currentProductIndex];
      var images = getImages(slide);
      if (images.length < 2) return;
      var idx = (getImageIndex(slide) + 1) % images.length;
      var img = slide.querySelector('.yeezy-carousel__image');
      preloadImage(images[idx].src, function () {
        withWipeTransition(img, 'ltr', function () {
          applyImage(slide, idx);
        });
      });
    }

    // ---- Produkty (kropki, swipe góra/dół) ----
    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentProductIndex);
      });
    }

    function goToProduct(targetIndex, direction) {
      targetIndex = (targetIndex + slides.length) % slides.length;
      if (targetIndex === currentProductIndex) return;

      var incoming = slides[targetIndex];
      var incomingImg = incoming.querySelector('.yeezy-carousel__image');
      var images = getImages(incoming);
      var firstItem = images[0];
      var wipeDirection = direction || 'btt';

      preloadImage(firstItem && firstItem.src, function () {
        withWipeTransition(incomingImg, wipeDirection, function () {
          slides[currentProductIndex].classList.remove('is-active');
          currentProductIndex = targetIndex;
          incoming.classList.add('is-active');
          applyImage(incoming, 0);
          updateDots();
        });
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', showPrevImage);
    if (nextBtn) nextBtn.addEventListener('click', showNextImage);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToProduct(i, i > currentProductIndex ? 'btt' : 'ttb');
      });
    });

    // ---- Swipe / przeciąganie: pozioma oś = zdjęcia, pionowa = produkty ----
    var dragStartX = 0;
    var dragStartY = 0;
    var dragCurrentX = 0;
    var dragCurrentY = 0;
    var isDragging = false;
    var DRAG_THRESHOLD = 40;

    function getPointer(event) {
      var point = event.touches ? event.touches[0] : event;
      return { x: point.clientX, y: point.clientY };
    }

    function dragStart(event) {
      if (event.target.closest('button, a, details, summary, select')) return;
      isDragging = true;
      var point = getPointer(event);
      dragStartX = point.x;
      dragStartY = point.y;
      dragCurrentX = dragStartX;
      dragCurrentY = dragStartY;
    }

    function dragMove(event) {
      if (!isDragging) return;
      var point = getPointer(event);
      dragCurrentX = point.x;
      dragCurrentY = point.y;
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      var deltaX = dragCurrentX - dragStartX;
      var deltaY = dragCurrentY - dragStartY;

      if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) return;

      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > 0) showPrevImage(); else showNextImage();
      } else {
        if (deltaY > 0) goToProduct(currentProductIndex - 1, 'ttb'); else goToProduct(currentProductIndex + 1, 'btt');
      }
    }

    if (stage) {
      stage.addEventListener('touchstart', dragStart, { passive: true });
      stage.addEventListener('touchmove', dragMove, { passive: true });
      stage.addEventListener('touchend', dragEnd);

      stage.addEventListener('mousedown', dragStart);
      window.addEventListener('mousemove', dragMove);
      window.addEventListener('mouseup', dragEnd);
    }

    // ---- Klawiatura: pomocniczo strzałki = zdjęcia, góra/dół = produkty ----
    document.addEventListener('keydown', function (event) {
      var tag = document.activeElement ? document.activeElement.tagName : '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (event.key === 'ArrowLeft') showPrevImage();
      if (event.key === 'ArrowRight') showNextImage();
      if (event.key === 'ArrowUp') goToProduct(currentProductIndex - 1, 'ttb');
      if (event.key === 'ArrowDown') goToProduct(currentProductIndex + 1, 'btt');
    });

    preloadProductImages(currentProductIndex);
    updateDots();
  }

  // ---- "Duch" lecący do koszyka (współdzielone przez karuzelę i quickview) ----
  if (!window.yeezyFlyToCart) {
    window.yeezyFlyToCart = function (sourceImg) {
      var cartEl = document.querySelector('.yeezy-header__cart') || document.querySelector('[data-yeezy-cart-count]');
      if (!sourceImg || !cartEl) return;

      var sourceRect = sourceImg.getBoundingClientRect();
      var cartRect = cartEl.getBoundingClientRect();

      var ghost = sourceImg.cloneNode(true);
      ghost.className = 'yeezy-fly-ghost';
      ghost.style.left = sourceRect.left + 'px';
      ghost.style.top = sourceRect.top + 'px';
      ghost.style.width = sourceRect.width + 'px';
      ghost.style.height = sourceRect.height + 'px';
      document.body.appendChild(ghost);

      var targetX = cartRect.left + cartRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
      var targetY = cartRect.top + cartRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

      var animation = ghost.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1, filter: 'blur(0px)' },
        { transform: 'translate(' + (targetX * 0.25) + 'px, ' + (targetY * 0.75) + 'px) scale(0.55)', opacity: 0.75, filter: 'blur(1px)', offset: 0.55 },
        { transform: 'translate(' + targetX + 'px, ' + targetY + 'px) scale(0.06)', opacity: 0, filter: 'blur(4px)' }
      ], {
        duration: 700,
        easing: 'cubic-bezier(0.3, 0.7, 0.35, 1)'
      });

      animation.onfinish = function () {
        ghost.remove();
      };
    };
  }
})();
